import styled from "styled-components";

export const SubTitle = styled.div.attrs({
  className: "text-sm",
})`
  color: var(--lightgray);
`;

export const FormGrid = styled.div.attrs({
  className: "mt-7",
})`
  display: grid;
  grid-template-columns: 1fr 4fr;
  padding-right: 12rem;

  @media screen and (max-width: 1000px) {
    padding-right: 0rem;
    display: block;
  }
`;

export const Container = styled.div.attrs({
  className: "",
})`
  margin-top: 3rem;
  padding-bottom: 10rem;
`;

export const Input = styled.input.attrs({
  className: "rounded w-full appearance-none focus:outline-none px-5 text-sm",
})`
  border: 1px solid #d4d4d8;
  height: 54px;
  background: whitesmoke;
  :disable {
    color: gray;
  }
`;

export const Avatar = styled.img.attrs({
  className: "",
})`
  border-radius: 10px;
  height: 50px;
  width: 50px;
  object-fit: cover;
`;

export const ProfileWrapper = styled.div.attrs({})`
  display: flex;
  align-items: center;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    margin-top: 1rem;
  }
`;

export const Select = styled.select.attrs({
  className: "rounded font-medium text-sm mb-3 px-3 mr-3  focus:outline-none",
})`
  border: 1px solid #d4d4d8;
  height: 40px;
  color: #71717a;
  background: #fbf8fc;
  width: 10rem;
  height: 3rem;
`;

export const Button = styled.button.attrs({
  className: "border-none block rounded text-white text-medium font-medium",
})`
  width: 12rem;
  display: block;
  color: var(--white);
  cursor: pointer;
  height: 4rem;
  background: var(--deepPurple);
  &:disabled {
    opacity: 0.5;
  }
  @media screen and (max-width: 768px) {
    width: 9rem;
    height: 3rem;
  }
`;
interface IButton {
  disabled?: boolean;
  buttonText?: string;
  type?: string;
}
export const UtilityBtn = styled.button.attrs({
  className: "border-none block rounded text-white text-medium font-medium",
})<IButton>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12rem;
  color: ${(props) => {
    if (props.buttonText === "Edit") {
      return "var(--white)";
    } else if (props.buttonText === "Cancel") {
      return "#000";
    } else {
      return "var(--white)";
    }
  }};
  cursor: pointer;
  height: 3rem;
  height: 55px;
  text-align: center;
  background-color: ${(props) => {
    if (props.buttonText === "Edit") {
      return "var(--deepPurple)";
    } else if (props.buttonText === "Cancel") {
      return "transparent";
    } else {
      return "var(--deepPurple)";
    }
  }};
  &:disabled {
    opacity: 0.5;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const UtilityBtnUpdate = styled(UtilityBtn)`
  background-color: var(--deepPurple);
  color: var(--white);
`;
export const UtilityBtnCancel = styled(UtilityBtn)`
  background-color: transparent;
  color: #000;
`;
export const EditBtn = styled.div.attrs({
  className: "border-none block rounded text-white text-medium font-medium",
})`
  width: 12rem;
  display: block;
  color: var(--white);
  cursor: pointer;
  height: 4rem;
  text-align: center;
  padding: 1.2rem;
  background: var(--deepPurple);

  @media screen and (max-width: 768px) {
    width: 9rem;
    height: 3rem;
  }
`;
export const CancelBtn = styled.div.attrs({
  className: "block text-medium font-medium",
})`
  width: 12rem;
  display: block;
  color: #000;
  cursor: pointer;
  height: 4rem;
  text-align: center;
  padding: 1.2rem;
  background: transparent;
`;
export const RelativeContainer = styled.div`
  position: relative;
`;
